export default "__VITE_ASSET__Dv4SEtGl__"